import script from "./DTS.vue?vue&type=script&setup=true&lang=ts"
export * from "./DTS.vue?vue&type=script&setup=true&lang=ts"

import "./DTS.vue?vue&type=style&index=0&id=e0d29200&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d29200"]])

export default __exports__